import imageCreek from "../../common/assets/bgCreek.png";
import imageNuevamente from "../../common/assets/bgNuevamente.png";
import imageHangover from "../../common/assets/bgHangover.png";
import imageLeparc from "../../common/assets/bgLeparc.png";


let bgLoginImage = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    bgLoginImage = imageCreek;
}else if (tenantId == "nuevamente") {
    bgLoginImage = imageNuevamente;
}else if (tenantId == "leparc") {
    bgLoginImage = imageLeparc;
}else if (tenantId == "hangover") {
    bgLoginImage = imageHangover;
}


export default bgLoginImage;


// WEBPACK FOOTER //
// ./src/screens/login/LoginImageSelector.js